import { Modal, Stack, Typography, IconButton } from "@mui/material";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import clientCodeImage from "assets/client-code.png";
import { useState } from "react";
import { IconWtts } from "components/Icons/IconWtts";
import { IconLetter } from "components/Icons/IconLetter";
import { IconHeadseat } from "components/Icons/IconHeadseat";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function ModalFindCode({ open, onClose }) {
  const [needHelp, setNeedHelp] = useState(false);

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus={true}>
      <ContentModal
        borderRadius={"16px"}
        style={{
          width: !needHelp ? "450px" : "600px",
        }}
      >
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          textAlign={"center"}
          p={"40px 32px"}
        >
          {!needHelp ? (
            <>
              <Typography fontSize={"32px"} fontWeight={600} color="#2CABF9">
                Localize seu código!
              </Typography>
              <Typography fontSize={"14px"} fontWeight={500} mt={"16px"}>
                Seu código de cliente está localizado no canto superior esquerdo
                do boleto.
              </Typography>
              <img
                src={clientCodeImage}
                style={{
                  marginTop: "24px",
                }}
              />
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                width={"100%"}
                mt={"52px"}
              >
                <Typography
                  fontSize={"16px"}
                  fontWeight={700}
                  color="#2CABF9"
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => setNeedHelp(true)}
                >
                  PRECISO DE AJUDA
                </Typography>
                <Typography
                  fontSize={"16px"}
                  fontWeight={700}
                  color="#2CABF9"
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={onClose}
                >
                  OK
                </Typography>
              </Stack>
            </>
          ) : (
            <Stack>
              <IconButton
                onClick={() => setNeedHelp(false)}
                sx={{ p: 0, alignSelf: "flex-start" }}
              >
                <ArrowBackIcon
                  sx={{
                    color: "#053462",
                    fontSize: "31px",
                  }}
                />
              </IconButton>
              <Typography fontSize={"25px"} fontWeight={700} mb={"18px"}>
                Precisando de ajuda?
              </Typography>

              <Typography
                fontSize={"14px"}
                fontWeight={500}
                color="#636363"
                align="justify"
                lineHeight={"100%"}
              >
                Entre em contato conosco pelo WhatsApp. Se você ainda não tiver
                o aplicativo instalado no seu smartphone, não tem problema!
                Envie-nos um e-mail e retornaremos o mais breve possível. Se
                preferir, você também pode ligar para os telefones do nosso CAC,
                listados abaixo.
              </Typography>
              <Stack
                alignItems={"center"}
                mt={6}
                mb={6}
                direction={"row"}
                justifyContent={"space-between"}
                width={"100%"}
              >
                <Stack
                  p={"16px"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  sx={{ cursor: "pointer" }}
                  bgcolor={"#053462"}
                  borderRadius={"8px"}
                  width={"15%"}
                  height={"80px"}
                  onClick={() =>
                    window.open(
                      `https://api.whatsapp.com/send?phone=5511997770000`,
                      "_blank"
                    )
                  }
                >
                  <IconWtts />
                  <Typography
                    fontWeight={600}
                    fontSize={"12px"}
                    color="#FFFFFF"
                  >
                    WhatsApp
                  </Typography>
                </Stack>
                <Stack
                  p={"16px"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  sx={{ cursor: "pointer" }}
                  bgcolor={"#053462"}
                  borderRadius={"8px"}
                  width={"15%"}
                  height={"80px"}
                  onClick={() =>
                    window.open("mailto:cac@consigaz.com.br", "_blank")
                  }
                >
                  <IconLetter />
                  <Typography
                    fontWeight={600}
                    fontSize={"12px"}
                    color="#FFFFFF"
                  >
                    Email
                  </Typography>
                </Stack>
                <Stack
                  p={"16px"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  borderRadius={"8px"}
                  width={"15%"}
                  height={"80px"}
                  border={"2px solid #053462"}
                >
                  <IconHeadseat />
                  <Typography
                    fontWeight={600}
                    fontSize={"10px"}
                    color="#053462"
                  >
                    0800 940 0244
                  </Typography>
                </Stack>
                <Stack
                  p={"16px"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  borderRadius={"8px"}
                  width={"15%"}
                  height={"80px"}
                  border={"2px solid #053462"}
                >
                  <IconHeadseat />
                  <Typography
                    fontWeight={600}
                    fontSize={"10px"}
                    color="#053462"
                  >
                    (11) 4766-9400
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          )}
        </Stack>
      </ContentModal>
    </Modal>
  );
}
